export const defaultImageValues = { previewImg: '', formData: new FormData() };
